import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import HomePage from "./pages/HomePage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ScrollToTop from "react-scroll-to-top";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";
import MasterLayout from "./layout/MasterLayout";
import useModals from "./helper/useModals";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function LanguageRedirect() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/") {
      navigate(`/${i18n.language}`, { replace: true });
    }
  }, [pathname, i18n.language, navigate]);

  return null;
}

function App() {
  const modals = useModals();
  return (
    <BrowserRouter>
      <LanguageRedirect />
      <RouteScrollToTop />
      <ScrollToTop color="#A847F0" />
      <Routes>
        <Route path="/" element={<MasterLayout {...modals} />}>
          <Route path=":lang">
            <Route index element={<HomePage {...modals} />} />
            <Route path="blog" element={<BlogPage {...modals} />} />
            <Route path="blog/:slug" element={<BlogDetailsPage />} />
            <Route path="contact" element={<ContactPage {...modals} />} />
          </Route>
        </Route>

        {/* 404 Page */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
